/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Platform_LabelInputs */

const en_gc_resources_download_platform_label = /** @type {(inputs: Gc_Resources_Download_Platform_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a download platform`)
};

const zh_gc_resources_download_platform_label = /** @type {(inputs: Gc_Resources_Download_Platform_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择下载平台`)
};

/**
* | output |
* | --- |
* | "Choose a download platform" |
*
* @param {Gc_Resources_Download_Platform_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_platform_label = /** @type {((inputs?: Gc_Resources_Download_Platform_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Platform_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_platform_label(inputs)
	return zh_gc_resources_download_platform_label(inputs)
});
export { gc_resources_download_platform_label as "gc.resources.download.platform_label" }